import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const newPlan = window.location.pathname === "/xplans/new";
const areas = ["Allergy", "Autoimmune", "Transplant", "Type 1 Diabetes"];

const Area = ({ area, handleChange, xplans, required }) => {
    return (
        <div id="area" className="planField">
            <GroupAllUsers />
            <Autocomplete
                name="area"
                multiple
                autoHighlight
                options={areas}
                value={area ? area.split(",") : []}
                onChange={(_, newValue) => handleChange("area", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={xplanLabels.area}
                        InputLabelProps={{
                            shrink: true,
                            required: required.includes("area")
                        }}
                        required={required.includes("area")}
                    />
                }
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"area"} />}
        </div>
    );
};

export default Area;
